<template>
    <div :class="['digital-classrooms-event__table-row-interval', {'show' : showDateDropDown}]" >
        <template v-if="isDesktopView && showEventName">
            <div class="digital-classrooms-event__table-cell digital-classrooms-event__interval-offset"></div>
        </template>
        <div class="digital-classrooms-event__table-cell digital-classrooms-event__interval-dates">
            <div class="digital-classrooms-event__interval-date" v-for="(session, index) in sessions" :key="index">
                {{ getIntervalEventDate(session) }}
            </div>
        </div>
        <div class="digital-classrooms-event__table-cell digital-classrooms-event__interval-times">
            <div class="digital-classrooms-event__interval-time" v-for="(session, index) in sessions" :key="index">
                {{ getIntervalEventTime(session) }}
            </div>
        </div>

        <div class="digital-classrooms-event__table-cell digital-classrooms-event__interval-durations">
            <div class="digital-classrooms-event__interval-duration" v-for="(session, index) in sessions" :key="index">
                {{ getIntervalEventDuration(session) }}
            </div>
        </div>
        <template v-if="isDesktopView">
            <div class="digital-classrooms-event__table-cell digital-classrooms-event__interval-offset"></div>
        </template>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    name:'EventDateRangeRow',
    props: {
        sessions: Array,
        showDateDropDown: Boolean,
        showEventName: Boolean
    },
    methods: {
        getIntervalEventTime (session) {
            return moment(session.startDateAndTime).format('HH:mm') + '-' +
                moment(session.endDateAndTime).format('HH:mm')
        },
        getIntervalEventDate (session) {
            return moment(session.startDateAndTime).format('DD.MM.YYYY')
        },
        getIntervalEventDuration (session) {
            let start = moment(session.startDateAndTime)
            let end = moment(session.endDateAndTime)

            const trainingDays = end.diff(start, 'days') + 1
            const differenceInHours = end.diff(start, 'hours')

            if (trainingDays === 1 && differenceInHours < 1) {
                return `${end.diff(start, 'minutes')} ${this.$t('DigitalClassrooms.minutes')}`
            }

            if (trainingDays === 1 && differenceInHours < 7) {
                if (end.diff(start, 'minutes') % 60 !== 0) {
                    return `${differenceInHours} ${this.$t('DigitalClassrooms.hoursAbbreviation')} ${end.diff(start, 'minutes') % 60} ${this.$t('DigitalClassrooms.minutesAbbreviation')}`
                }
                return `${differenceInHours} ${this.$t('DigitalClassrooms.hours')}`
            }
            return `${trainingDays} ${this.$t('DigitalClassrooms.days')}`
        }
    }
};
</script>

<style lang="scss" scoped>
    @include digital-classrooms-table;
    @include digital-classrooms-event;
</style>
